import { createContext, useContext, type ReactNode } from 'react'
import type { WebContainer } from '../../../deps/containers.types'

const WebContainerContext = createContext<WebContainer | null>(null)

export type DepProviderProps = {
  container: WebContainer
  children: ReactNode
}

/**
 * Provides the app's dependency container to container components.
 *
 * This lets container components access deps without threading props through the tree.
 */
export function DepProvider({ container, children }: DepProviderProps) {
  return <WebContainerContext.Provider value={container}>{children}</WebContainerContext.Provider>
}

export function useWebContainer(): WebContainer {
  const ctx = useContext(WebContainerContext)
  if (!ctx) throw new Error('useWebContainer must be used within DepProvider')
  return ctx
}

